import skSk from "antd/lib/locale/sk_SK";
import enUs from "antd/lib/locale/en_US";

export const getLocaleByShortcut = shortcut => {
  return shortcut === "sk" ? skSk : enUs;
};
